<div class="gridItemChildModule w-100 h-100 d-flex flex-column KPITrendContentContainer">
    <div id="KPITrendChartArea" *ngIf="!noData && !intervalRangeTooWide && !isNoMetric">
        <div class="chartScaler">
            <canvas
                baseChart
                *ngIf="chartConfig"
                [type]="chartConfig.type"
                [legend]="chartConfig.options.plugins.legend.display"
                [datasets]="chartConfig.data.datasets"
                [labels]="chartConfig.data.labels"
                [options]="chartConfig.options"
                [plugins]="chartConfig.plugins"
            >
            </canvas>
        </div>
    </div>
    <app-module-error
        class="flex-fill"
        *ngIf="isNoMetric"
        [noMetric]="true"
    ></app-module-error>
    <app-module-error
        class="flex-fill"
        *ngIf="intervalRangeTooWide"
        [intervalRangeTooWide]="true"
    ></app-module-error>
    <app-module-error
        class="flex-fill"
        *ngIf="noData"
        [noData]="true"
    ></app-module-error>
</div>
